import { render } from "./FriendListModal.vue?vue&type=template&id=038a6d0c&scoped=true"
import script from "./FriendListModal.vue?vue&type=script&lang=js"
export * from "./FriendListModal.vue?vue&type=script&lang=js"

import "./FriendListModal.vue?vue&type=style&index=0&id=038a6d0c&scoped=true&lang=css"

import exportComponent from "/var/www/happy-quiz-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038a6d0c"]])

export default __exports__